import * as React from "react";
const SvgProfile = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	"xmlns:svgjs": "http://svgjs.com/svgjs",
	viewBox: "0 0 128 128",
	width: 128,
	height: 128,
	...props
}, /* @__PURE__ */ React.createElement("g", { transform: "matrix(5.333333333333333,0,0,5.333333333333333,0,0)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M6.500 6.750 A5.500 5.500 0 1 0 17.500 6.750 A5.500 5.500 0 1 0 6.500 6.750 Z",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3,22.75a9,9,0,0,1,18,0Z",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round"
})));
export { SvgProfile as ReactComponent };
